<template>
  <v-app>
    <v-content>
      <v-navigation-drawer app clipped v-model="drawer" v-if="!isCleanPage">
        <sp-categories></sp-categories>
      </v-navigation-drawer>
      <sp-toolbar @menu="toggleDrawer" v-if="!isCleanPage"></sp-toolbar>
      <v-container fluid grid-list-md :fill-height="isCleanPage" 
        :class="{'accent lighten-2':isCleanPage}" style="padding-bottom:200px">
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="100"
      >
          <v-card height="100" width="100" color="transparent">
            <v-layout justify-center align-center fill-height>
                <v-progress-circular
                  :size="50"
                  :width="7"
                  color="secondary"
                  indeterminate
                ></v-progress-circular>
            </v-layout>
          </v-card>
      </v-dialog>
  </v-app>
</template>

<script>

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


import {mapGetters} from 'vuex'

import SpToolbar from './components/SpToolbar'
import SpCategories from './components/SpCategories'

export default {
  name: 'App',
  components:{
    SpToolbar,
    SpCategories
  },
  data(){
    return {
      drawer:true
    }
  },
  computed:{
    ...mapGetters([
      'loading',
      'isCleanPage'
    ]),
  },
  methods:{
    toggleDrawer(){
      this.drawer = !this.drawer
    }
  }
}
</script>

<style lang="scss">

  .sp-transparent{
    background-color: rgba(0, 0, 0, 0.45) !important
  }
  .sp-transparent-red{
    background-color: rgba(255, 0, 0, 0.45) !important
  }

  ::-webkit-scrollbar {
    width: 10px;
  }


  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--v-secondary-lighten2);
    border-radius: 3px; 
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--v-secondary-lighten1);
  }

  /* Resizer */
  ::-webkit-resizer{
    background-image: url("https://api.socialplace.com.br/static/icons/resize.png");
    background-repeat: no-repeat;
    background-size:contain;
  }

  .draggable .v-sheet{
    -webkit-transition: none !important;
    transition: none !important;
  }

  .draggable .v-expansion-panel__container{
    -webkit-transition: none !important;
    transition: none !important;
  }

  .sp-drag:hover {
    cursor: grab;
  }
  .sp-click:hover {
    cursor: pointer;
  }

</style>

